import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  MoneyFlowType,
  PropertyManagement,
  PropertyTransaction,
  WalletTransaction,
} from './property-management.model';
import { dummyDataProperty } from '@shared/dummyData/property-405';
import { Document, FileType } from '../properties/properties.model';

@Injectable({
  providedIn: 'root',
})
export class PropertyManagementService {
  readonly propertyManagement$: Observable<PropertyManagement | null>;
  readonly isPropertyManagementLoading$: Observable<boolean>;

  private readonly _propertyManagement$: BehaviorSubject<PropertyManagement | null> =
    new BehaviorSubject<PropertyManagement | null>(null);
  private readonly _isPropertyManagementLoading$: BehaviorSubject<boolean> =
    new BehaviorSubject(false);

  constructor() {
    this.propertyManagement$ = this._propertyManagement$.asObservable();
    this.isPropertyManagementLoading$ =
      this._isPropertyManagementLoading$.asObservable();
  }

  getPropertyManagement(): void {
    this._isPropertyManagementLoading$.next(true);

    const propertyManagement: PropertyManagement = {
      property: dummyDataProperty,

      documents: [
        {
          name: 'Title deed',
          type: FileType.PDF,
          url: 'https://drive.google.com/file/d/1Zee8ALx3ZqUyZNPfuoncCb-MPGbztyZU/view?usp=sharing',
          canBeDeleted: true,
        },
        {
          name: 'Projections',
          type: FileType.XLSX,
          url: 'https://drive.google.com/file/d/1Zee8ALx3ZqUyZNPfuoncCb-MPGbztyZU/view?usp=sharing',
        },
        {
          name: 'Share certificate',
          type: FileType.PDF,
          url: 'https://drive.google.com/file/d/1Aj17cx2y555L7egs7lgtmUSkK8zTHf4o/view?usp=sharing',
        },
        {
          name: 'Rent',
          type: FileType.PDF,
          url: 'https://drive.google.com/file/d/1Aj17cx2y555L7egs7lgtmUSkK8zTHf4o/view?usp=sharing',
        },
      ],
      transactions: [
        {
          type: WalletTransaction.RENTAL_PAID,
          moneyFlow: MoneyFlowType.INCOME,
          date: new Date('2025-04-30'),
          amount: 1005.2,
          isEditable: false,
        },
        {
          type: WalletTransaction.MANAGEMENT_FEE,
          moneyFlow: MoneyFlowType.OUTCOME,
          date: new Date('2025-04-26'),
          amount: 1005.2,
          isEditable: false,
        },
        {
          type: WalletTransaction.RENTAL_PAID,
          moneyFlow: MoneyFlowType.INCOME,
          date: new Date('2025-04-25'),
          amount: 2000,
          isEditable: false,
        },
        {
          type: WalletTransaction.PROPERTY_TAX,
          moneyFlow: MoneyFlowType.OUTCOME,
          date: new Date('2025-03-27'),
          amount: 500,
          isEditable: false,
        },
        {
          type: WalletTransaction.RENTAL_PAID,
          moneyFlow: MoneyFlowType.INCOME,
          date: new Date('2025-02-27'),
          amount: 2000,
          isEditable: false,
        },
        {
          type: WalletTransaction.OTHER_EXPENSE,
          moneyFlow: MoneyFlowType.OUTCOME,
          date: new Date('2025-02-05'),
          amount: 100,
          isEditable: false,
        },
        {
          type: WalletTransaction.OTHER_EXPENSE,
          moneyFlow: MoneyFlowType.OUTCOME,
          date: new Date('2025-02-05'),
          amount: 100,
          isEditable: false,
        },
        {
          type: WalletTransaction.RENTAL_PAID,
          moneyFlow: MoneyFlowType.INCOME,
          date: new Date('2025-01-31'),
          amount: 2000,
          isEditable: false,
        },
      ],

      // Property value
      totalValue: 12353,
      growthOverviewChartDates: [
        new Date('2024-11-01'),
        new Date('2024-12-10'),
        new Date('2024-12-30'),
        new Date('2025-01-05'),
        new Date('2025-02-25'),
        new Date('2025-03-01'),
        new Date('2025-03-31'),
      ],
      growthOverviewChartValues: [0, 505, 3756, 5890, 6501, 8302, 12353],

      // Key financials
      monthlyIncome: 510,
      totalRentalIncome: 105204,
      totalAppreciation: 55001,
      financialPeriod: new Date('2025-02-01'),
    };

    setTimeout(() => {
      this._propertyManagement$.next(propertyManagement);
      this._isPropertyManagementLoading$.next(false);
    }, 2000);
  }

  addDocument(document: Document): void {
    const propertyManagement: PropertyManagement = {
      ...this._propertyManagement$.value!,
    };

    propertyManagement.documents.unshift(document);

    this._propertyManagement$.next(propertyManagement);
  }

  addTransaction(transactions: PropertyTransaction): void {
    const propertyManagement: PropertyManagement = {
      ...this._propertyManagement$.value!,
    };

    propertyManagement.transactions.unshift(transactions);

    this._propertyManagement$.next(propertyManagement);
  }
}
